import { IInventoryContext } from "Interfaces/Providers/Inventory";
import { InventoryContext } from "providers/Settings/Inventory";
import { useContext } from "react";

export default function useInventory(): IInventoryContext {
  const context = useContext(InventoryContext);

  return context;
}
